module.exports = __webpack_public_path__ + "static/media/pdfSvgrepoCom.62f001ee.svg";